<div class="refresh-indicator" [style.top.px]="-50 + refreshMovement">
  <mat-progress-spinner
    diameter="24"
    color="accent"
    mode="determinate"
    [value]="refreshProgress * 80"
    [style.opacity]="refreshProgress === 1 ? 1 : 0.4"
    *ngIf="isPulling"
  >
  </mat-progress-spinner>

  <mat-progress-spinner diameter="24" color="accent" mode="indeterminate" *ngIf="isUpdating">
  </mat-progress-spinner>
</div>

<ng-content></ng-content>
